<template>
  <div class="customer" :class="!isHideCustom ? 'hidecustomer' : ''">
    <div class="customer-head">
      <div class="title">客服</div>
      <div class="oper">
        <div
          :class="!isHideCustom ? 'hidereduce' : 'reduce'"
          @click="customerHide()"
        ></div>
        <div class="plus" @click="close()"></div>
      </div>
    </div>
    <div
      v-if="isHideCustom"
      class="customer-body"
      id="customer-body"
      @scroll="loadList($event)"
      ref="fios"
      @click="showEmojiPanel(2)"
    >
      <div class="loading" v-if="isloading === false"></div>
      <template v-for="(item, index) in list" :key="index">
        <div class="customer-body-left" v-if="item.SendType === 1">
          <!-- 客服 -->
          <img :src="item.Avatar" class="avatar" alt="" />
          <!--商品信息 卡片 -->
          <div
            class="miniprogrampage"
            @click="toProduct(item.PagePath)"
            v-if="item.MsgType === 1"
          >
            <div class="head">
              <!-- <div class="headPhoto"></div> -->
              <div class="pagename">小程序</div>
            </div>
            <div class="pagetitle">{{ item.Title }}</div>
            <div
              class="minphoto"
              :style="{ 'background-image': `url(${item.Photo})` }"
            ></div>
          </div>
          <!--文字 -->
          <div class="msg" v-if="item.MsgType === 2">
            <template v-for="(item, idx) in item.parsedComment" :key="idx">
              <template v-if="item.type === 1">
                {{ item.content }}
              </template>
              <div v-if="item.type === 2" style="width: 24px; height: 24px">
                <div
                  :class="item.imageClass"
                  style="transform-origin: 0 0; transform: scale(0.375)"
                  :style="{ 'background-image': `url(${emojiSource})` }"
                ></div>
              </div>
            </template>
          </div>
          <!--图片-->
          <a :href="item.Photo" v-else-if="item.MsgType == 3" target="_blank">
            <img :src="item.Photo" class="msgphoto" />
          </a>
        </div>

        <div class="customer-body-right" v-if="item.SendType === 0">
          <!-- 用户 -->
          <img :src="item.Avatar" class="avatar" alt="" />
          <div class="msg">
            <template v-for="(item, idx) in item.parsedComment" :key="idx">
              <template v-if="item.type === 1">
                {{ item.content }}
              </template>

              <div v-if="item.type === 2" style="width: 24px; height: 24px">
                <div
                  :class="item.imageClass"
                  style="transform-origin: 0 0; transform: scale(0.375)"
                  :style="{ 'background-image': `url(${emojiSource})` }"
                ></div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>

    <div v-if="isHideCustom" class="customer-footer">
      <div class="content">
        <input
          id="content"
          type="text"
          v-model="content"
          @keyup.enter.stop="sendMsg()"
          @focus="showEmojiPanel(2)"
          placeholder="请在这里输入文字"
        />
        <img
          src="../assets/images/reply_tool_emoji.svg"
          @click="showEmojiPanel(1)"
          alt="表情"
        />
      </div>

      <div class="btn" @click="sendMsg()">发送</div>
    </div>
    <div class="emoji-area" v-if="showEmoji">
      <div
        style="margin-left: 3px; cursor: pointer"
        class="emotion_item"
        v-for="(item, index) in emojis"
        :key="index"
      >
        <div
          class="icon_emotion"
          :class="item.style"
          :data-cn="item.cn"
          :data-index="index"
          @click="chooseEmoji(item.cn)"
          style="background-image: url(https://kuaijikf.darga.cn/emoji.png)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as signalR from '@microsoft/signalr'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import parseEmoji from '../js/parseEmoji'
import { postNoLoading, getPost } from '../utils/posts'
export default {
  setup (props, context) {
    const emojiSource = ref('https://kuaijikf.darga.cn/emoji.png')
    const emojis = ref([
      {
        id: 0,
        cn: '[微笑]',
        hk: '[微笑]',
        us: '[Smile]',
        code: '/::)',
        web_code: '/微笑',
        style: 'smiley_0'
      },
      {
        id: 1,
        cn: '[撇嘴]',
        hk: '[撇嘴]',
        us: '[Grimace]',
        code: '/::~',
        web_code: '/撇嘴',
        style: 'smiley_1'
      },
      {
        id: 2,
        cn: '[色]',
        hk: '[色]',
        us: '[Drool]',
        code: '/::B',
        web_code: '/色',
        style: 'smiley_2'
      },
      {
        id: 3,
        cn: '[发呆]',
        hk: '[發呆]',
        us: '[Scowl]',
        code: '/::|',
        web_code: '/发呆',
        style: 'smiley_3'
      },
      {
        id: 4,
        cn: '[得意]',
        hk: '[得意]',
        us: '[CoolGuy]',
        code: '/:8-)',
        web_code: '/得意',
        style: 'smiley_4'
      },
      {
        id: 5,
        cn: '[流泪]',
        hk: '[流淚]',
        us: '[Sob]',
        code: '/::<',
        web_code: '/流泪',
        style: 'smiley_5'
      },
      {
        id: 6,
        cn: '[害羞]',
        hk: '[害羞]',
        us: '[Shy]',
        code: '/::$',
        web_code: '/害羞',
        style: 'smiley_6'
      },
      {
        id: 7,
        cn: '[闭嘴]',
        hk: '[閉嘴]',
        us: '[Silent]',
        code: '/::X',
        web_code: '/闭嘴',
        style: 'smiley_7'
      },
      {
        id: 8,
        cn: '[睡]',
        hk: '[睡]',
        us: '[Sleep]',
        code: '/::Z',
        web_code: '/睡',
        style: 'smiley_8'
      },
      {
        id: 9,
        cn: '[大哭]',
        hk: '[大哭]',
        us: '[Cry]',
        code: '/::"(',
        web_code: '/大哭',
        style: 'smiley_9'
      },
      {
        id: 10,
        cn: '[尴尬]',
        hk: '[尷尬]',
        us: '[Awkward]',
        code: '/::-|',
        web_code: '/尴尬',
        style: 'smiley_10'
      },
      {
        id: 11,
        cn: '[发怒]',
        hk: '[發怒]',
        us: '[Angry]',
        code: '/::@',
        web_code: '/发怒',
        style: 'smiley_11'
      },
      {
        id: 12,
        cn: '[调皮]',
        hk: '[調皮]',
        us: '[Tongue]',
        code: '/::P',
        web_code: '/调皮',
        style: 'smiley_12'
      },
      {
        id: 13,
        cn: '[呲牙]',
        hk: '[呲牙]',
        us: '[Grin]',
        code: '/::D',
        web_code: '/呲牙',
        style: 'smiley_13'
      },
      {
        id: 14,
        cn: '[惊讶]',
        hk: '[驚訝]',
        us: '[Surprise]',
        code: '/::O',
        web_code: '/惊讶',
        style: 'smiley_14'
      },
      {
        id: 15,
        cn: '[难过]',
        hk: '[難過]',
        us: '[Frown]',
        code: '/::(',
        web_code: '/难过',
        style: 'smiley_15'
      },
      {
        id: 17,
        cn: '[冷汗]',
        hk: '[冷汗]',
        us: '[Blush]',
        code: '/:--b',
        web_code: '/冷汗',
        style: 'smiley_17'
      },
      {
        id: 18,
        cn: '[抓狂]',
        hk: '[抓狂]',
        us: '[Scream]',
        code: '/::Q',
        web_code: '/抓狂',
        style: 'smiley_18'
      },
      {
        id: 19,
        cn: '[吐]',
        hk: '[吐]',
        us: '[Puke]',
        code: '/::T',
        web_code: '/吐',
        style: 'smiley_19'
      },
      {
        id: 20,
        cn: '[偷笑]',
        hk: '[偷笑]',
        us: '[Chuckle]',
        code: '/:,@P',
        web_code: '/偷笑',
        style: 'smiley_20'
      },
      {
        id: 21,
        cn: '[愉快]',
        hk: '[愉快]',
        us: '[Joyful]',
        code: '/:,@-D',
        web_code: '/可爱',
        style: 'smiley_21'
      },
      {
        id: 22,
        cn: '[白眼]',
        hk: '[白眼]',
        us: '[Slight]',
        code: '/::d',
        web_code: '/白眼',
        style: 'smiley_22'
      },
      {
        id: 23,
        cn: '[傲慢]',
        hk: '[傲慢]',
        us: '[Smug]',
        code: '/:,@o',
        web_code: '/傲慢',
        style: 'smiley_23'
      },
      {
        id: 25,
        cn: '[困]',
        hk: '[累]',
        us: '[Drowsy]',
        code: '/:|-)',
        web_code: '/困',
        style: 'smiley_25'
      },
      {
        id: 26,
        cn: '[惊恐]',
        hk: '[驚恐]',
        us: '[Panic]',
        code: '/::!',
        web_code: '/惊恐',
        style: 'smiley_26'
      },
      {
        id: 27,
        cn: '[流汗]',
        hk: '[流汗]',
        us: '[Sweat]',
        code: '/::L',
        web_code: '/流汗',
        style: 'smiley_27'
      },
      {
        id: 28,
        cn: '[憨笑]',
        hk: '[大笑]',
        us: '[Laugh]',
        code: '/::>',
        web_code: '/憨笑',
        style: 'smiley_28'
      },
      {
        id: 29,
        cn: '[悠闲]',
        hk: '[悠閑]',
        us: '[Commando]',
        code: '/::,@',
        web_code: '/大兵',
        style: 'smiley_29'
      },
      {
        id: 30,
        cn: '[奋斗]',
        hk: '[奮鬥]',
        us: '[Determined]',
        code: '/:,@f',
        web_code: '/奋斗',
        style: 'smiley_30'
      },
      {
        id: 31,
        cn: '[咒骂]',
        hk: '[咒罵]',
        us: '[Scold]',
        code: '/::-S',
        web_code: '/咒骂',
        style: 'smiley_31'
      },
      {
        id: 32,
        cn: '[疑问]',
        hk: '[疑問]',
        us: '[Shocked]',
        code: '/:?',
        web_code: '/疑问',
        style: 'smiley_32'
      },
      {
        id: 33,
        cn: '[嘘]',
        hk: '[噓]',
        us: '[Shhh]',
        code: '/:,@x',
        web_code: '/嘘',
        style: 'smiley_33'
      },
      {
        id: 34,
        cn: '[晕]',
        hk: '[暈]',
        us: '[Dizzy]',
        code: '/:,@@',
        web_code: '/晕',
        style: 'smiley_34'
      },
      {
        id: 36,
        cn: '[衰]',
        hk: '[衰]',
        us: '[Toasted]',
        code: '/:,@!',
        web_code: '/衰',
        style: 'smiley_36'
      },
      {
        id: 37,
        cn: '[骷髅]',
        hk: '[骷髏頭]',
        us: '[Skull]',
        code: '/:!!!',
        web_code: '/骷髅',
        style: 'smiley_37'
      },
      {
        id: 38,
        cn: '[敲打]',
        hk: '[敲打]',
        us: '[Hammer]',
        code: '/:xx',
        web_code: '/敲打',
        style: 'smiley_38'
      },
      {
        id: 39,
        cn: '[再见]',
        hk: '[再見]',
        us: '[Wave]',
        code: '/:bye',
        web_code: '/再见',
        style: 'smiley_39'
      },
      {
        id: 40,
        cn: '[擦汗]',
        hk: '[擦汗]',
        us: '[Speechless]',
        code: '/:wipe',
        web_code: '/擦汗',
        style: 'smiley_40'
      },
      {
        id: 41,
        cn: '[抠鼻]',
        hk: '[摳鼻]',
        us: '[NosePick]',
        code: '/:dig',
        web_code: '/抠鼻',
        style: 'smiley_41'
      },
      {
        id: 42,
        cn: '[鼓掌]',
        hk: '[鼓掌]',
        us: '[Clap]',
        code: '/:handclap',
        web_code: '/鼓掌',
        style: 'smiley_42'
      },
      {
        id: 44,
        cn: '[坏笑]',
        hk: '[壞笑]',
        us: '[Trick]',
        code: '/:B-)',
        web_code: '/坏笑',
        style: 'smiley_44'
      },
      {
        id: 45,
        cn: '[左哼哼]',
        hk: '[左哼哼]',
        us: '[Bah！L]',
        code: '/:<@',
        web_code: '/左哼哼',
        style: 'smiley_45'
      },
      {
        id: 46,
        cn: '[右哼哼]',
        hk: '[右哼哼]',
        us: '[Bah！R]',
        code: '/:@>',
        web_code: '/右哼哼',
        style: 'smiley_46'
      },
      {
        id: 47,
        cn: '[哈欠]',
        hk: '[哈欠]',
        us: '[Yawn]',
        code: '/::-O',
        web_code: '/哈欠',
        style: 'smiley_47'
      },
      {
        id: 48,
        cn: '[鄙视]',
        hk: '[鄙視]',
        us: '[Pooh-pooh]',
        code: '/:>-|',
        web_code: '/鄙视',
        style: 'smiley_48'
      },
      {
        id: 49,
        cn: '[委屈]',
        hk: '[委屈]',
        us: '[Shrunken]',
        code: '/:P-(',
        web_code: '/委屈',
        style: 'smiley_49'
      },
      {
        id: 50,
        cn: '[快哭了]',
        hk: '[快哭了]',
        us: '[TearingUp]',
        code: '/::"|',
        web_code: '/快哭了',
        style: 'smiley_50'
      },
      {
        id: 51,
        cn: '[阴险]',
        hk: '[陰險]',
        us: '[Sly]',
        code: '/:X-)',
        web_code: '/阴险',
        style: 'smiley_51'
      },
      {
        id: 52,
        cn: '[亲亲]',
        hk: '[親親]',
        us: '[Kiss]',
        code: '/::*',
        web_code: '/亲亲',
        style: 'smiley_52'
      },
      {
        id: 54,
        cn: '[可怜]',
        hk: '[可憐]',
        us: '[Whimper]',
        code: '/:8*',
        web_code: '/可怜',
        style: 'smiley_54'
      },
      {
        id: 55,
        cn: '[菜刀]',
        hk: '[菜刀]',
        us: '[Cleaver]',
        code: '/:pd',
        web_code: '/菜刀',
        style: 'smiley_55'
      },
      {
        id: 56,
        cn: '[西瓜]',
        hk: '[西瓜]',
        us: '[Watermelon]',
        code: '/:<W>',
        web_code: '/西瓜',
        style: 'smiley_56'
      },
      {
        id: 57,
        cn: '[啤酒]',
        hk: '[啤酒]',
        us: '[Beer]',
        code: '/:beer',
        web_code: '/啤酒',
        style: 'smiley_57'
      },
      {
        id: 60,
        cn: '[咖啡]',
        hk: '[咖啡]',
        us: '[Coffee]',
        code: '/:coffee',
        web_code: '/咖啡',
        style: 'smiley_60'
      },
      {
        id: 62,
        cn: '[猪头]',
        hk: '[豬頭]',
        us: '[Pig]',
        code: '/:pig',
        web_code: '/猪头',
        style: 'smiley_62'
      },
      {
        id: 63,
        cn: '[玫瑰]',
        hk: '[玫瑰]',
        us: '[Rose]',
        code: '/:rose',
        web_code: '/玫瑰',
        style: 'smiley_63'
      },
      {
        id: 64,
        cn: '[凋谢]',
        hk: '[枯萎]',
        us: '[Wilt]',
        code: '/:fade',
        web_code: '/凋谢',
        style: 'smiley_64'
      },
      {
        id: 65,
        cn: '[嘴唇]',
        hk: '[嘴唇]',
        us: '[Lips]',
        code: '/:showlove',
        web_code: '/示爱',
        style: 'smiley_65'
      },
      {
        id: 66,
        cn: '[爱心]',
        hk: '[愛心]',
        us: '[Heart]',
        code: '/:heart',
        web_code: '/爱心',
        style: 'smiley_66'
      },
      {
        id: 67,
        cn: '[心碎]',
        hk: '[心碎]',
        us: '[BrokenHeart]',
        code: '/:break',
        web_code: '/心碎',
        style: 'smiley_67'
      },
      {
        id: 68,
        cn: '[蛋糕]',
        hk: '[蛋糕]',
        us: '[Cake]',
        code: '/:cake',
        web_code: '/蛋糕',
        style: 'smiley_68'
      },
      {
        id: 70,
        cn: '[炸弹]',
        hk: '[炸彈]',
        us: '[Bomb]',
        code: '/:bome',
        web_code: '/炸弹',
        style: 'smiley_70'
      },
      {
        id: 74,
        cn: '[便便]',
        hk: '[便便]',
        us: '[Poop]',
        code: '/:shit',
        web_code: '/便便',
        style: 'smiley_74'
      },
      {
        id: 75,
        cn: '[月亮]',
        hk: '[月亮]',
        us: '[Moon]',
        code: '/:moon',
        web_code: '/月亮',
        style: 'smiley_75'
      },
      {
        id: 76,
        cn: '[太阳]',
        hk: '[太陽]',
        us: '[Sun]',
        code: '/:sun',
        web_code: '/太阳',
        style: 'smiley_76'
      },
      {
        id: 78,
        cn: '[拥抱]',
        hk: '[擁抱]',
        us: '[Hug]',
        code: '/:hug',
        web_code: '/拥抱',
        style: 'smiley_78'
      },
      {
        id: 79,
        cn: '[强]',
        hk: '[強]',
        us: '[ThumbsUp]',
        code: '/:strong',
        web_code: '/强',
        style: 'smiley_79'
      },
      {
        id: 80,
        cn: '[弱]',
        hk: '[弱]',
        us: '[ThumbsDown]',
        code: '/:weak',
        web_code: '/弱',
        style: 'smiley_80'
      },
      {
        id: 81,
        cn: '[握手]',
        hk: '[握手]',
        us: '[Shake]',
        code: '/:share',
        web_code: '/握手',
        style: 'smiley_81'
      },
      {
        id: 82,
        cn: '[胜利]',
        hk: '[勝利]',
        us: '[Peace]',
        code: '/:v',
        web_code: '/胜利',
        style: 'smiley_82'
      },
      {
        id: 83,
        cn: '[抱拳]',
        hk: '[抱拳]',
        us: '[Fight]',
        code: '/:@)',
        web_code: '/抱拳',
        style: 'smiley_83'
      },
      {
        id: 84,
        cn: '[勾引]',
        hk: '[勾引]',
        us: '[Beckon]',
        code: '/:jj',
        web_code: '/勾引',
        style: 'smiley_84'
      },
      {
        id: 85,
        cn: '[拳头]',
        hk: '[拳頭]',
        us: '[Fist]',
        code: '/:@@',
        web_code: '/拳头',
        style: 'smiley_85'
      },
      {
        id: 89,
        cn: '[OK]',
        hk: '[OK]',
        us: '[OK]',
        code: '/:ok',
        web_code: '/OK',
        style: 'smiley_89'
      },
      {
        id: 92,
        cn: '[跳跳]',
        hk: '[跳跳]',
        us: '[Waddle]',
        code: '/:jump',
        web_code: '/跳跳',
        style: 'smiley_92'
      },
      {
        id: 93,
        cn: '[发抖]',
        hk: '[發抖]',
        us: '[Tremble]',
        code: '/:shake',
        web_code: '/发抖',
        style: 'smiley_93'
      },
      {
        id: 94,
        cn: '[怄火]',
        hk: '[噴火]',
        us: '[Aaagh!]',
        code: '/:<O>',
        web_code: '/怄火',
        style: 'smiley_94'
      },
      {
        id: 95,
        cn: '[转圈]',
        hk: '[轉圈]',
        us: '[Twirl]',
        code: '/:circle',
        web_code: '/转圈',
        style: 'smiley_95'
      },
      {
        id: 300,
        cn: '[笑脸]',
        emoji: '😄',
        hk: '',
        us: '',
        code: '\\ue415',
        web_code: '',
        style: 'u1F604'
      },
      {
        id: 301,
        cn: '[生病]',
        emoji: '😷',
        hk: '',
        us: '',
        code: '\\ue40c',
        web_code: '',
        style: 'u1F637'
      },
      {
        id: 302,
        cn: '[破涕为笑]',
        emoji: '😂',
        hk: '',
        us: '',
        code: '\\ue412',
        web_code: '',
        style: 'u1F602'
      },
      {
        id: 303,
        cn: '[吐舌]',
        emoji: '😝',
        hk: '',
        us: '',
        code: '\\ue409',
        web_code: '',
        style: 'u1F61D'
      },
      {
        id: 304,
        cn: '[脸红]',
        emoji: '😳',
        hk: '',
        us: '',
        code: '\\ue40d',
        web_code: '',
        style: 'u1F633'
      },
      {
        id: 305,
        cn: '[恐惧]',
        emoji: '😱',
        hk: '',
        us: '',
        code: '\\ue107',
        web_code: '',
        style: 'u1F631'
      },
      {
        id: 306,
        cn: '[失望]',
        emoji: '😔',
        hk: '',
        us: '',
        code: '\\ue403',
        web_code: '',
        style: 'u1F614'
      },
      {
        id: 307,
        cn: '[无语]',
        emoji: '😒',
        hk: '',
        us: '',
        code: '\\ue40e',
        web_code: '',
        style: 'u1F612'
      },
      {
        id: 204,
        cn: '[嘿哈]',
        hk: '[吼嘿]',
        us: '[Hey]',
        code: '',
        web_code: '',
        style: 'e2_04'
      },
      {
        id: 205,
        cn: '[捂脸]',
        hk: '[掩面]',
        us: '[Facepalm]',
        code: '',
        web_code: '',
        style: 'e2_05'
      },
      {
        id: 202,
        cn: '[奸笑]',
        hk: '[奸笑]',
        us: '[Smirk]',
        code: '',
        web_code: '',
        style: 'e2_02'
      },
      {
        id: 206,
        cn: '[机智]',
        hk: '[機智]',
        us: '[Smart]',
        code: '',
        web_code: '',
        style: 'e2_06'
      },
      {
        id: 212,
        cn: '[皱眉]',
        hk: '[皺眉]',
        us: '[Moue]',
        code: '',
        web_code: '',
        style: 'e2_12'
      },
      {
        id: 211,
        cn: '[耶]',
        hk: '[歐耶]',
        us: '[Yeah!]',
        code: '',
        web_code: '',
        style: 'e2_11'
      },
      {
        id: 313,
        cn: '[吃瓜]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_313'
      },
      {
        id: 314,
        cn: '[加油]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_314'
      },
      {
        id: 315,
        cn: '[汗]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_315'
      },
      {
        id: 316,
        cn: '[天啊]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_316'
      },
      {
        id: 317,
        cn: '[Emm]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_317'
      },
      {
        id: 318,
        cn: '[社会社会]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_318'
      },
      {
        id: 319,
        cn: '[旺柴]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_319'
      },
      {
        id: 320,
        cn: '[好的]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_320'
      },
      {
        id: 321,
        cn: '[打脸]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_321'
      },
      {
        id: 322,
        cn: '[哇]',
        hk: '[]',
        us: '[]',
        code: '',
        web_code: '',
        style: 'smiley_322'
      },
      {
        id: 308,
        cn: '[鬼魂]',
        emoji: '👻',
        hk: '',
        us: '',
        code: '\\ue11b',
        web_code: '',
        style: 'u1F47B'
      },
      {
        id: 309,
        cn: '[合十]',
        emoji: '🙏',
        hk: '',
        us: '',
        code: '\\ue41d',
        web_code: '',
        style: 'u1F64F'
      },
      {
        id: 310,
        cn: '[强壮]',
        emoji: '💪',
        hk: '',
        us: '',
        code: '\\ue14c',
        web_code: '',
        style: 'u1F4AA'
      },
      {
        id: 311,
        cn: '[庆祝]',
        emoji: '🎉',
        hk: '',
        us: '',
        code: '\\ue312',
        web_code: '',
        style: 'u1F389'
      },
      {
        id: 312,
        cn: '[礼物]',
        hk: '',
        us: '',
        code: '\\ue112',
        web_code: '',
        style: 'u1F381'
      },
      {
        id: 209,
        cn: '[红包]',
        hk: '[Packet]',
        us: '[Packet]',
        code: '',
        web_code: '',
        style: 'e2_09'
      }
    ])

    const router = useRouter()
    const store = useStore()
    // const customerType = store.state.customerType // 客服类型
    const appId = store.state.appId
    // appId = customerType === 1 ? appId : 'sj-' + appId
    const userInfo = store.state.userInfo
    // const router=useRouter();

    const supplierId = store.state.supplierId
    const supplierName = store.state.supplierName
    const supplierAvatar = store.state.supplierAvatar

    const isHideCustom = ref(true)

    const list = ref([])
    const showEmoji = ref(false)

    const content = ref('')

    const isloading = ref(false)
    const page = ref(1)
    const pageCount = ref(99)

    let connection = null
    // 隐藏客服对话框
    const customerHide = () => {
      isHideCustom.value = !isHideCustom.value
    }
    // 关闭客服
    const close = () => {
      context.emit('closeCustomer')
    }
    // 加载聊天记录
    const getList = () => {
      getPost(
        `https://kuaijikf.darga.cn/api/Message/get?sAppId=${appId}&sOpenId=${userInfo.openId}&iCompanyId=${supplierId}&page=${page.value}`
      ).then((res) => {
        const datas = res.data
        datas.forEach((item) => {
          item.parsedComment = parseEmoji(item.Content)
        })

        pageCount.value = res.pageCount
        if (page.value > 1) {
          // 页数大于1 要把列表在前面插入
          list.value.unshift(...datas.reverse())
          let scroll = 0
          // 回到加载前位置
          const con = document.getElementById('customer-body')
          datas.forEach((item, index) => {
            scroll += con.children[index].offsetHeight
          })
          con.scrollTo(0, scroll)
        } else {
          list.value = datas.reverse()
          toBottom()
        }

        isloading.value = true
      })
      // store.dispatch('mget', {
      //   url: `https://kuaijikf.darga.cn/api/Message/get?sAppId=${appId}&sOpenId=${userInfo.openId}&iCompanyId=0&page=${page.value}`,
      //   callback: (res) => {
      //     const datas = res.data
      //     datas.forEach((item) => {
      //       item.parsedComment = parseEmoji(item.Content)
      //     })

      //     pageCount.value = res.pageCount
      //     if (page.value > 1) {
      //       // 页数大于1 要把列表在前面插入
      //       list.value.unshift(...datas.reverse())
      //       let scroll = 0
      //       // 回到加载前位置
      //       const con = document.getElementById('customer-body')
      //       datas.forEach((item, index) => {
      //         scroll += con.children[index].offsetHeight
      //       })
      //       con.scrollTo(0, scroll)
      //     } else {
      //       list.value = datas.reverse()
      //       toBottom()
      //     }

      //     isloading.value = true
      //   }
      // })
    }
    // 显示表情面板
    const showEmojiPanel = (val) => {
      if (val === 1) showEmoji.value = !showEmoji.value
      else showEmoji.value = false
    }
    // 选择表情
    const chooseEmoji = (cn) => {
      content.value += cn
      document.getElementById('content').focus()
      showEmoji.value = false
    }
    // 发送消息
    const sendMsg = () => {
      const msg = content.value

      if (!msg) {
        ElMessage({
          showClose: true,
          message: '不能发送空消息',
          type: 'error',
          customClass: 'zZindex'
        })
        return
      }
      const data = {
        AppId: appId,
        OpenId: userInfo.openId,
        CompanyId: supplierId,
        NickName: userInfo.nickName,
        Avatar: userInfo.avatar,
        SendState: 0,
        SendType: 0,
        MsgType: 2,
        Content: msg
      }

      postData(data)
      content.value = ''
    }
    // 将要发送的信息推到服务器
    const postData = (data) => {
      postNoLoading('https://kuaijikf.darga.cn/api/Message/send', data).then(
        (res) => {}
      )
    }
    // 连接socket
    const connectStock = () => {
      // 连接用户
      postNoLoading('https://kuaijikf.darga.cn/api/Users/connect', {
        AppId: appId,
        OpenId: userInfo.openId,
        NickName: userInfo.nickName,
        Avatar: userInfo.avatar,
        CompanyId: supplierId,
        CompanyName: supplierName,
        CompanyAvatar: supplierAvatar
      }).then((res) => {})

      connection = new signalR.HubConnectionBuilder()
        .withUrl(
          `https://kuaijikf.darga.cn/ChatHub?OpenId=${userInfo.openId}&AppId=${appId}&CompanyId=${supplierId}`
        )
        .configureLogging(signalR.LogLevel.Information)
        .build()

      connection.on('ReceiveMessage', (obj) => {
        const arr = []
        const msgdata = JSON.parse(obj)
        arr.push(msgdata)

        arr.forEach((item) => {
          if (item.Content != null) {
            item.parsedComment = parseEmoji(item.Content)
          }
        })
        list.value = list.value.concat(arr)
        toBottom()
      })

      connection.start().catch((err) => {
        console.log(11111111111111111111, err)
      })
      connection.onclose((res) => {
        console.log(res)
      })
    }
    // 滚动条置底
    const toBottom = () => {
      setTimeout(() => {
        // eslint-disable-next-line camelcase
        const customer_body = document.getElementById('customer-body')
        const height = customer_body.scrollHeight
        customer_body.scrollTo(0, height)
      }, 50)
    }
    // 上拉加载
    const loadList = (e) => {
      const target = e.target
      const scrollTop = target.scrollTop
      if (scrollTop === 0) {
        if (isloading.value) {
          page.value += 1
          if (page.value > pageCount.value) return
          isloading.value = false
          getList()
        }
      }
    }
    // 商品详情
    const toProduct = (url) => {
      const pid = url.split('=')[1]
      if (pid) {
        router.push({ path: `/product/detail/${pid}` })
      }
    }

    onMounted(() => {
      if (!userInfo) {
        store.state.isCustomCustomer = false
        ElMessage({
          showClose: true,
          message: '请登录',
          type: 'error',
          customClass: 'zZindex'
        })
        // router.push({name:'login'})
      } else {
        getList()
        connectStock()
      }
    })
    onUnmounted(() => {
      // console.log(connection)
    })
    return {
      loadList,
      getList,
      sendMsg,
      showEmojiPanel,
      chooseEmoji,
      customerHide,
      close,
      toProduct,
      isHideCustom,
      list,
      emojiSource,
      emojis,
      showEmoji,
      content,
      isloading,
      page,
      pageCount
    }
  },
  directives: {
    drag (el) {
      el.onmousedown = function () {
        // var disx = e.pageX - el.offsetLeft;
        // var disy = e.pageY - el.offsetTop;
        document.onmousemove = function (e) {
          el.style.left = e.pageX + 'px'
          // el.style.top = e.pageY+'px';
        }
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null
        }
      }
    }
  }
}
</script>

<style lang="scss" >
.zZindex {
  z-index: 9999 !important;
}
.loading {
  width: 20px;
  height: 20px;
  margin: auto;
  /* margin-right: 10px; */
  -webkit-animation: _loading 1s steps(12, end) infinite;
  animation: _loading 1s steps(12, end) infinite;
  background: transparent
    url("data:image/svg+xml;charset=utf8, %3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 100 100'%3E%3Cpath fill='none' d='M0 0h100v100H0z'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23E9E9E9' rx='5' ry='5' transform='translate(0 -30)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23989697' rx='5' ry='5' transform='rotate(30 105.98 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%239B999A' rx='5' ry='5' transform='rotate(60 75.98 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23A3A1A2' rx='5' ry='5' transform='rotate(90 65 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23ABA9AA' rx='5' ry='5' transform='rotate(120 58.66 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23B2B2B2' rx='5' ry='5' transform='rotate(150 54.02 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23BAB8B9' rx='5' ry='5' transform='rotate(180 50 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23C2C0C1' rx='5' ry='5' transform='rotate(-150 45.98 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23CBCBCB' rx='5' ry='5' transform='rotate(-120 41.34 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23D2D2D2' rx='5' ry='5' transform='rotate(-90 35 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23DADADA' rx='5' ry='5' transform='rotate(-60 24.02 65)'/%3E%3Crect width='7' height='20' x='46.5' y='40' fill='%23E2E2E2' rx='5' ry='5' transform='rotate(-30 -5.98 65)'/%3E%3C/svg%3E")
    no-repeat;
  background-size: 100%;
}
@-webkit-keyframes _loading {
  0% {
    transform: rotate3d(0, 0, 1, 0deg);
  }

  100% {
    transform: rotate3d(0, 0, 1, 360deg);
  }
}

@keyframes _loading {
  0% {
    transform: rotate3d(0, 0, 1, 0deg);
  }

  100% {
    transform: rotate3d(0, 0, 1, 360deg);
  }
}

.customer {
  position: fixed;
  top: 120px;
  left: 20px;
  width: 500px;
  height: 800px;
  background-color: #f8f6f6;
  z-index: 9998;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 2px 20px 4px rgba(0, 0, 0, 0.2);
  .customer-head {
    padding: 20px;
    font-size: 18px;
    background-color: #333;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    color: #e4a846;
    .oper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 24px;
      .reduce {
        width: 30px;
        position: relative;
        margin-right: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 30px;
        &::before {
          position: absolute;
          content: "";
          left: 0;
          right: 0;
          margin: auto;
          width: 24px;
          height: 2px;
          background-color: #e4a846;
        }
        &:hover {
          background-color: #444;
        }
      }
      .hidereduce {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 30px;
        margin-right: 20px;
        cursor: pointer;
        &::before {
          position: absolute;
          content: "";
          top: 1px;
          width: 16px;
          height: 16px;
          border: solid #e4a846;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
        &:hover {
          background-color: #444;
        }
      }
      .plus {
        position: relative;
        height: 30px;
        width: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &::before {
          position: absolute;
          content: "";

          width: 2px;
          height: 24px;
          background-color: #e4a846;
          transform: rotate(45deg);
        }
        &::after {
          position: absolute;
          content: "";

          width: 24px;
          height: 2px;
          background-color: #e4a846;
          cursor: pointer;
          transform: rotate(45deg);
        }
        &:hover {
          background-color: #444;
        }
      }
    }
  }
  .customer-body::-webkit-scrollbar {
    width: 4px;
    height: 1px;
    border-radius: 4px;
  }
  .customer-body::-webkit-scrollbar-thumb {
    border-radius: 4px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgb(158, 156, 156);
  }

  /*滚动条轨道*/
  .customer-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 4px;
    background: #f5f5f5;
  }

  .customer-body {
    flex: 1;
    background-color: #fff;
    margin: 10px;
    border-radius: 6px;
    overflow-y: scroll;
    .miniprogrampage {
      margin-left: 10px;
      width: 200px;
      padding-bottom: 20px;
      background-color: #fff;
      border-radius: 4px;
      cursor: pointer;
      box-shadow: 0 1px 7px rgba(5, 1, 1, 0.25);
      .head {
        margin: 6px 0;
        height: 30px;

        display: flex;
        align-items: center;
        .headPhoto {
          height: 20px;
          width: 20px;
          background-color: red;
          border-radius: 20px;
          margin-left: 10px;
        }
        .pagename {
          font-size: 14px;
          margin-left: 10px;
          color: #ccc;
        }
      }
      .pagetitle {
        font-size: 14px;
        color: #333;
        margin-left: 10px;
        margin-bottom: 10px;
        overflow: hidden;
        display: -webkit-box;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-all;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .minphoto {
        margin-left: 10px;
        width: 180px;
        height: 160px;
        background: no-repeat center/cover;
      }
      .bottomTitle {
        color: #cccccc;
        font-size: 14px;
        margin-left: 10px;
        padding-top: 6px;
      }
    }
    .msgphoto {
      margin-left: 10px;
      max-width: 150px;
      max-height: 200px;
      min-width: 60px;
      min-height: 10px;
      box-shadow: 0 1px 7px rgba(5, 1, 1, 0.25);
      background: no-repeat center/cover;
    }

    .customer-body-left {
      padding: 10px;
      min-height: 40px;
      display: flex;

      .avatar {
        width: 44px;
        height: 44px;
        border-radius: 44px;
      }
      .msg {
        margin-left: 10px;
        max-width: 340px;
        padding: 10px;
        min-height: 10px;
        border-radius: 0 6px 6px 6px;
        font-size: 14px;
        background-color: #999;
        color: #fff;
        word-break: break-all;
        word-wrap: break-word;
        position: relative;
        &::before {
          position: absolute;
          content: "";
          left: -9px;
          top: 0;
          width: 0;
          height: 0;
          border-top: 10px solid #999;
          border-left: 10px solid transparent;
        }
      }
    }
    .customer-body-right {
      padding: 10px;
      min-height: 40px;
      display: flex;

      flex-direction: row-reverse;
      .avatar {
        width: 44px;
        height: 44px;
        border-radius: 44px;
      }
      .msg {
        margin-right: 10px;
        max-width: 340px;
        padding: 10px;
        min-height: 10px;
        border-radius: 6px 0 6px 6px;
        font-size: 14px;
        background-color: #999;
        color: #fff;
        word-break: break-all;
        word-wrap: break-word;
        position: relative;

        &::before {
          position: absolute;
          content: "";
          right: -9px;
          top: 0;
          width: 0;
          height: 0;
          border-top: 10px solid #999;
          border-right: 10px solid transparent;
        }
      }
    }
    .msg > div {
      display: inline-block;
      overflow: hidden;
      vertical-align: middle;
    }
  }
  .customer-footer {
    margin: 0 10px 10px 10px;
    display: flex;
    bottom: 0px;
    height: 60px;
    border-radius: 6px;
    justify-content: space-between;
    align-items: center;
    .content {
      height: 50px;
      border-radius: 6px;
      flex: 1;
      margin-right: 10px;
      font-size: 18px;
      background-color: #fff;
      display: flex;
      align-items: center;
      overflow: hidden;
      input {
        padding: 0 10px;
        height: 50px;
        flex: 1;
      }
      img {
        width: 36px;
        height: 36px;
        cursor: pointer;
      }
    }
    .btn {
      width: 120px;
      text-align: center;
      line-height: 50px;
      background-color: #e4a846;
      color: #fff;
      height: 50px;
      font-size: 20px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .emoji-area {
    position: absolute;
    bottom: 70px;
    width: 476px;
    height: 300px;
    margin: 0 10px;
    background-color: #fff;
    overflow-y: auto;
    padding: 10px 0;
    border-radius: 6px 6px 0 0;
    box-shadow: 1px -3px 9px rgba(0, 0, 0, 0.2);
    .emotion_item {
      display: inline-block;
      position: relative;
      width: 40px;
      height: 40px;
      padding-bottom: 5px;
      line-height: 40px;
    }
    .icon_emotion {
      position: absolute;
      top: 4px;
      left: 4px;
      display: inline-block;
      transform-origin: 0 0;
      transform: scale(0.5);
    }
  }
}
.hidecustomer {
  top: 0px;
  left: 0px;
  height: 0px;
}

.e2_02,
.e2_04,
.e2_05,
.e2_06,
.e2_09,
.e2_11,
.e2_12,
.e2_14,
.smiley_0,
.smiley_1,
.smiley_10,
.smiley_11,
.smiley_12,
.smiley_13,
.smiley_14,
.smiley_15,
.smiley_17,
.smiley_18,
.smiley_19,
.smiley_2,
.smiley_20,
.smiley_21,
.smiley_22,
.smiley_23,
.smiley_25,
.smiley_26,
.smiley_27,
.smiley_28,
.smiley_29,
.smiley_3,
.smiley_30,
.smiley_31,
.smiley_313,
.smiley_314,
.smiley_315,
.smiley_316,
.smiley_317,
.smiley_318,
.smiley_319,
.smiley_32,
.smiley_320,
.smiley_321,
.smiley_322,
.smiley_33,
.smiley_34,
.smiley_36,
.smiley_37,
.smiley_38,
.smiley_39,
.smiley_4,
.smiley_40,
.smiley_41,
.smiley_42,
.smiley_44,
.smiley_45,
.smiley_46,
.smiley_47,
.smiley_48,
.smiley_49,
.smiley_5,
.smiley_50,
.smiley_51,
.smiley_52,
.smiley_54,
.smiley_55,
.smiley_56,
.smiley_57,
.smiley_6,
.smiley_60,
.smiley_61,
.smiley_62,
.smiley_63,
.smiley_64,
.smiley_65,
.smiley_66,
.smiley_67,
.smiley_68,
.smiley_7,
.smiley_70,
.smiley_74,
.smiley_75,
.smiley_76,
.smiley_78,
.smiley_79,
.smiley_8,
.smiley_80,
.smiley_81,
.smiley_82,
.smiley_83,
.smiley_84,
.smiley_85,
.smiley_89,
.smiley_9,
.smiley_92,
.smiley_93,
.smiley_94,
.smiley_95,
.u1F381,
.u1F389,
.u1F47B,
.u1F4AA,
.u1F602,
.u1F604,
.u1F612,
.u1F614,
.u1F61D,
.u1F631,
.u1F633,
.u1F637,
.u1F64F {
  display: inline-block;
  background-repeat: no-repeat;
}

.e2_02 {
  width: 64px;
  height: 64px;
  background-position: -66px 0;
}

.e2_04 {
  width: 64px;
  height: 64px;
  background-position: -462px -396px;
}

.e2_05 {
  width: 64px;
  height: 64px;
  background-position: 0 -66px;
}

.e2_06 {
  width: 64px;
  height: 64px;
  background-position: -66px -66px;
}

.e2_09 {
  width: 64px;
  height: 64px;
  background-position: -132px 0;
}

.e2_11 {
  width: 64px;
  height: 64px;
  background-position: -132px -66px;
}

.e2_12 {
  width: 64px;
  height: 64px;
  background-position: 0 -132px;
}

.e2_14 {
  width: 64px;
  height: 64px;
  background-position: -66px -132px;
}

.smiley_0 {
  width: 64px;
  height: 64px;
  background-position: -132px -132px;
}

.smiley_1 {
  width: 63px;
  height: 64px;
  background-position: -660px -594px;
}

.smiley_10 {
  width: 64px;
  height: 64px;
  background-position: -198px -66px;
}

.smiley_11 {
  width: 64px;
  height: 64px;
  background-position: -198px -132px;
}

.smiley_12 {
  width: 64px;
  height: 64px;
  background-position: 0 -198px;
}

.smiley_13 {
  width: 64px;
  height: 64px;
  background-position: -66px -198px;
}

.smiley_14 {
  width: 64px;
  height: 64px;
  background-position: -132px -198px;
}

.smiley_15 {
  width: 64px;
  height: 64px;
  background-position: -198px -198px;
}

.smiley_17 {
  width: 64px;
  height: 64px;
  background-position: -264px 0;
}

.smiley_18 {
  width: 64px;
  height: 64px;
  background-position: -264px -66px;
}

.smiley_19 {
  width: 64px;
  height: 64px;
  background-position: -264px -132px;
}

.smiley_2 {
  width: 64px;
  height: 64px;
  background-position: -264px -198px;
}

.smiley_20 {
  width: 64px;
  height: 64px;
  background-position: 0 -264px;
}

.smiley_21 {
  width: 64px;
  height: 64px;
  background-position: -66px -264px;
}

.smiley_22 {
  width: 64px;
  height: 64px;
  background-position: -132px -264px;
}

.smiley_23 {
  width: 64px;
  height: 64px;
  background-position: -198px -264px;
}

.smiley_25 {
  width: 64px;
  height: 64px;
  background-position: -264px -264px;
}

.smiley_26 {
  width: 64px;
  height: 64px;
  background-position: -330px 0;
}

.smiley_27 {
  width: 64px;
  height: 64px;
  background-position: -330px -66px;
}

.smiley_28 {
  width: 64px;
  height: 64px;
  background-position: -330px -132px;
}

.smiley_29 {
  width: 64px;
  height: 64px;
  background-position: -330px -198px;
}

.smiley_3 {
  width: 64px;
  height: 64px;
  background-position: -330px -264px;
}

.smiley_30 {
  width: 64px;
  height: 64px;
  background-position: 0 -330px;
}

.smiley_31 {
  width: 64px;
  height: 64px;
  background-position: -66px -330px;
}

.smiley_313 {
  width: 64px;
  height: 64px;
  background-position: -132px -330px;
}

.smiley_314 {
  width: 64px;
  height: 64px;
  background-position: -198px -330px;
}

.smiley_315 {
  width: 64px;
  height: 64px;
  background-position: -264px -330px;
}

.smiley_316 {
  width: 64px;
  height: 64px;
  background-position: -330px -330px;
}

.smiley_317 {
  width: 64px;
  height: 64px;
  background-position: -396px 0;
}

.smiley_318 {
  width: 64px;
  height: 64px;
  background-position: -396px -66px;
}

.smiley_319 {
  width: 64px;
  height: 64px;
  background-position: -396px -132px;
}

.smiley_32 {
  width: 64px;
  height: 64px;
  background-position: -396px -198px;
}

.smiley_320 {
  width: 64px;
  height: 64px;
  background-position: -396px -264px;
}

.smiley_321 {
  width: 64px;
  height: 64px;
  background-position: -396px -330px;
}

.smiley_322 {
  width: 64px;
  height: 64px;
  background-position: 0 -396px;
}

.smiley_33 {
  width: 64px;
  height: 64px;
  background-position: -66px -396px;
}

.smiley_34 {
  width: 64px;
  height: 64px;
  background-position: -132px -396px;
}

.smiley_36 {
  width: 64px;
  height: 64px;
  background-position: -198px -396px;
}

.smiley_37 {
  width: 64px;
  height: 64px;
  background-position: -264px -396px;
}

.smiley_38 {
  width: 64px;
  height: 64px;
  background-position: -330px -396px;
}

.smiley_39 {
  width: 64px;
  height: 64px;
  background-position: -396px -396px;
}

.smiley_4 {
  width: 64px;
  height: 64px;
  background-position: -462px 0;
}

.smiley_40 {
  width: 64px;
  height: 64px;
  background-position: -462px -66px;
}

.smiley_41 {
  width: 64px;
  height: 64px;
  background-position: -462px -132px;
}

.smiley_42 {
  width: 64px;
  height: 64px;
  background-position: -462px -198px;
}

.smiley_44 {
  width: 64px;
  height: 64px;
  background-position: -462px -264px;
}

.smiley_45 {
  width: 64px;
  height: 64px;
  background-position: -462px -330px;
}

.smiley_46 {
  width: 64px;
  height: 64px;
  background-position: 0 0;
}

.smiley_47 {
  width: 64px;
  height: 64px;
  background-position: 0 -462px;
}

.smiley_48 {
  width: 64px;
  height: 64px;
  background-position: -66px -462px;
}

.smiley_49 {
  width: 64px;
  height: 64px;
  background-position: -132px -462px;
}

.smiley_5 {
  width: 64px;
  height: 64px;
  background-position: -198px -462px;
}

.smiley_50 {
  width: 64px;
  height: 64px;
  background-position: -264px -462px;
}

.smiley_51 {
  width: 64px;
  height: 64px;
  background-position: -330px -462px;
}

.smiley_52 {
  width: 64px;
  height: 64px;
  background-position: -396px -462px;
}

.smiley_54 {
  width: 64px;
  height: 64px;
  background-position: -462px -462px;
}

.smiley_55 {
  width: 64px;
  height: 64px;
  background-position: -528px 0;
}

.smiley_56 {
  width: 64px;
  height: 64px;
  background-position: -528px -66px;
}

.smiley_57 {
  width: 64px;
  height: 64px;
  background-position: -528px -132px;
}

.smiley_6 {
  width: 64px;
  height: 64px;
  background-position: -528px -198px;
}

.smiley_60 {
  width: 64px;
  height: 64px;
  background-position: -528px -264px;
}

.smiley_61 {
  width: 64px;
  height: 64px;
  background-position: -528px -330px;
}

.smiley_62 {
  width: 64px;
  height: 64px;
  background-position: -528px -396px;
}

.smiley_63 {
  width: 64px;
  height: 64px;
  background-position: -528px -462px;
}

.smiley_64 {
  width: 64px;
  height: 64px;
  background-position: 0 -528px;
}

.smiley_65 {
  width: 64px;
  height: 64px;
  background-position: -66px -528px;
}

.smiley_66 {
  width: 64px;
  height: 64px;
  background-position: -132px -528px;
}

.smiley_67 {
  width: 64px;
  height: 64px;
  background-position: -198px -528px;
}

.smiley_68 {
  width: 64px;
  height: 64px;
  background-position: -264px -528px;
}

.smiley_7 {
  width: 64px;
  height: 64px;
  background-position: -330px -528px;
}

.smiley_70 {
  width: 64px;
  height: 64px;
  background-position: -396px -528px;
}

.smiley_74 {
  width: 64px;
  height: 64px;
  background-position: -462px -528px;
}

.smiley_75 {
  width: 64px;
  height: 64px;
  background-position: -528px -528px;
}

.smiley_76 {
  width: 64px;
  height: 64px;
  background-position: -594px 0;
}

.smiley_78 {
  width: 64px;
  height: 64px;
  background-position: -594px -66px;
}

.smiley_79 {
  width: 64px;
  height: 64px;
  background-position: -594px -132px;
}

.smiley_8 {
  width: 64px;
  height: 64px;
  background-position: -594px -198px;
}

.smiley_80 {
  width: 64px;
  height: 64px;
  background-position: -594px -264px;
}

.smiley_81 {
  width: 64px;
  height: 64px;
  background-position: -594px -330px;
}

.smiley_82 {
  width: 64px;
  height: 64px;
  background-position: -594px -396px;
}

.smiley_83 {
  width: 64px;
  height: 64px;
  background-position: -594px -462px;
}

.smiley_84 {
  width: 64px;
  height: 64px;
  background-position: -594px -528px;
}

.smiley_85 {
  width: 64px;
  height: 64px;
  background-position: 0 -594px;
}

.smiley_89 {
  width: 64px;
  height: 64px;
  background-position: -66px -594px;
}

.smiley_9 {
  width: 64px;
  height: 64px;
  background-position: -132px -594px;
}

.smiley_92 {
  width: 64px;
  height: 64px;
  background-position: -198px -594px;
}

.smiley_93 {
  width: 64px;
  height: 64px;
  background-position: -264px -594px;
}

.smiley_94 {
  width: 64px;
  height: 64px;
  background-position: -330px -594px;
}

.smiley_95 {
  width: 64px;
  height: 64px;
  background-position: -396px -594px;
}

.u1F381 {
  width: 64px;
  height: 64px;
  background-position: -462px -594px;
}

.u1F389 {
  width: 64px;
  height: 64px;
  background-position: -528px -594px;
}

.u1F47B {
  width: 64px;
  height: 64px;
  background-position: -594px -594px;
}

.u1F4AA {
  width: 64px;
  height: 64px;
  background-position: -660px 0;
}

.u1F602 {
  width: 64px;
  height: 64px;
  background-position: -660px -66px;
}

.u1F604 {
  width: 64px;
  height: 64px;
  background-position: -660px -132px;
}

.u1F612 {
  width: 64px;
  height: 64px;
  background-position: -660px -198px;
}

.u1F614 {
  width: 64px;
  height: 64px;
  background-position: -660px -264px;
}

.u1F61D {
  width: 64px;
  height: 64px;
  background-position: -660px -330px;
}

.u1F631 {
  width: 64px;
  height: 64px;
  background-position: -660px -396px;
}

.u1F633 {
  width: 64px;
  height: 64px;
  background-position: -660px -462px;
}

.u1F637 {
  width: 64px;
  height: 64px;
  background-position: -198px 0;
}

.u1F64F {
  width: 64px;
  height: 64px;
  background-position: -660px -528px;
}
</style>
